/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { Flex } from "@powerledger/ui-component-lib";
import { FC } from "react";

import { OnboardingStepperContext } from "./context";
import { OnboardingProviderProps } from "./onboarding.types";
import { OnboardingFormWrapper } from "./onboarding-form-wrapper/onboarding-form-wrapper";
import { OnboardingHeader } from "./onboarding-header/onboarding-header";
import { OnboardingSider } from "./onboarding-sider/onboarding-sider";

export const OnboardingProvider: FC<OnboardingProviderProps> = ({
  providerValues,
  saveAndExit,
  steps,
  initialFormValues,
  currentValidationSchema,
  getCurrentTouched,
  formRef,
}) => {
  return (
    <OnboardingStepperContext.Provider value={providerValues}>
      <OnboardingHeader saveAndExit={saveAndExit} isSavingBeforeExit={providerValues.isSavingBeforeExit} />
      <Flex
        sx={{
          width: "100%",
          minHeight: "100vh",
          flexDirection: "row",
        }}
      >
        <OnboardingSider steps={steps} />
        <OnboardingFormWrapper
          currentStep={providerValues.currentStep}
          currentStage={providerValues.currentStage}
          initialFormValues={initialFormValues}
          currentValidationSchema={currentValidationSchema}
          getCurrentTouched={getCurrentTouched}
          formRef={formRef}
          currentStageComponent={steps[providerValues.currentStep].stages[providerValues.currentStage]?.component}
        />
      </Flex>
    </OnboardingStepperContext.Provider>
  );
};
